<template>
<div>
    <router-link :to="'pardakht-shakhsi/'+row.id+'/details'" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fa fa-eye"></i>
    </router-link>
</div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
})
</script>

<style>

</style>